<div class="header">
<!--  <notification-alert></notification-alert>-->
  <div class="login">
    <span class="sing-in text-uppercase" (click)="goToLogin()">Log out</span>
  </div>
</div>

